export enum CommunicationView {
  SMS = 1,
  SMS_SEND = 2,
  EMAIL = 3,
  EMAIL_SEND = 4,
}
